import { render, staticRenderFns } from "./PagamentosTab.vue?vue&type=template&id=b6462c8c"
import script from "./PagamentosTab.vue?vue&type=script&lang=js"
export * from "./PagamentosTab.vue?vue&type=script&lang=js"
import style0 from "./PagamentosTab.vue?vue&type=style&index=0&id=b6462c8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports